import { ERROR_CODES } from '../../constants';


const { network_error } = ERROR_CODES;

export const SERIAL_ERROR_CODES: { [key: string]: string } = {
  serial_id_not_exists_asn: 'serial_id_not_exists_asn',
  serial_id_duplicate: 'serial_id_duplicate',
  serial_id_composite_duplicate: 'serial_id_composite_duplicate',
  serial_id_cannot_receive: 'serial_id_cannot_receive',
  serail_not_available_to_scan: 'serail_not_available_to_scan',
  network_error: 'network_error',
  SERIALID_NOT_EXPECTED_IN_SHIPMENT: 'SERIALID_NOT_EXPECTED_IN_SHIPMENT',
  COMPOSITE_DUPLICATE_SERIAL: 'COMPOSITE_DUPLICATE_SERIAL',
  SERIAL_ALREADY_EXISTS: 'SERIAL_ALREADY_EXISTS',
  SERIAL_SPECIAL_CHARACTERS: 'SERIAL_SPECIAL_CHARACTERS',
  MPN_NOT_EXPECTED_IN_RECEIVE_REFERENCE: 'MPN_NOT_EXPECTED_IN_RECEIVE_REFERENCE',
  FAILED_VALIDATION: 'FAILED_VALIDATION',
  FAILED_LINE_ITEM_RECONCILIATION: 'FAILED_LINE_ITEM_RECONCILIATION',
  FAILED_INVENTORY_UPDATE: 'FAILED_INVENTORY_UPDATE',
  MPN_IPN_COMBINATION_NOT_FOUND: 'MPN_IPN_COMBINATION_NOT_FOUND',
  SERIALID_NOT_EXPECTED_IN_SHIPMENT_PSIR_NOT_REQUIRED: 'SERIALID_NOT_EXPECTED_IN_SHIPMENT_PSIR_NOT_REQUIRED',
  SERIALID_NOT_EXPECTED_IN_SHIPMENT_PSIR_REQUIRED: 'SERIALID_NOT_EXPECTED_IN_SHIPMENT_PSIR_REQUIRED',
  COMPOSITE_DUPLICATE_SERIAL_INVALID_STATE: 'COMPOSITE_DUPLICATE_SERIAL_INVALID_STATE',
  MOBILITY_SERVICE_NOT_AVAILABLE: 'MOBILITY_SERVICE_NOT_AVAILABLE',
  TOWNSEND_IDENTIFIER_COMBINATION_INVALID: 'TOWNSEND_IDENTIFIER_COMBINATION_INVALID',
  SERIAL_ALREADY_RECEIVED_FOR_SHIPMENT: 'SERIAL_ALREADY_RECEIVED_FOR_SHIPMENT',

  // ERROR codes from Execution Service
  SERIAL_DUPLICATE_SITE_SPECIFIC_VALIDATION: 'SERIAL_DUPLICATE_SITE_SPECIFIC_VALIDATION',
  SERIAL_DUPLICATE_COMPOSITE_MATCH_VALIDATION: 'SERIAL_DUPLICATE_SITE_SPECIFIC_VALIDATION',
  INVENTORY_ADJUSTMENT_SERIAL_FAILURE_DUPLICATE_INVENTORY_MODIFICATION:
    'INVENTORY_ADJUSTMENT_SERIAL_FAILURE_DUPLICATE_INVENTORY_MODIFICATION',
  INVENTORY_ADJUSTMENT_SERIAL_FAILURE_UNEXPECTED_INVENTORY_MODIFICATION:
    'INVENTORY_ADJUSTMENT_SERIAL_FAILURE_UNEXPECTED_INVENTORY_MODIFICATION',
  INVENTORY_ADJUSTMENT_SERIAL_FAILURE_THROTTLED_INVENTORY_MODIFICATION:
    'INVENTORY_ADJUSTMENT_SERIAL_FAILURE_THROTTLED_INVENTORY_MODIFICATION',
  SERIAL_MPN_NOT_EXPECTED_IN_RECEIVE_VALIDATION: 'SERIAL_MPN_NOT_EXPECTED_IN_RECEIVE_VALIDATION',
  SCOS_RECEIPTS_NOTIFY_FAILURE_DEPENDENCY_NOTIFICATION: 'SCOS_RECEIPTS_NOTIFY_FAILURE_DEPENDENCY_NOTIFICATION',
  SERIAL_TOWNSEND_IDENTIFIER_COMBINATION_INVALID_VALIDATION: 'SERIAL_TOWNSEND_IDENTIFIER_COMBINATION_INVALID_VALIDATION',
  SERIAL_UNEXPECTED_ERROR: 'SERIAL_UNEXPECTED_ERROR',

  SERIAL_DUPLICATE_ERROR: 'SERIAL_DUPLICATE_ERROR',
  SERIAL_EXPECTED_IN_SHIPMENT: 'SERIAL_EXPECTED_IN_SHIPMENT',

};

export const SERIAL_ERROR_CODES_MAPPING: { [key: string]: string } = {
  serial_id_not_exists_asn: 'A part with this serial number is not expected in the shipment',
  serial_id_duplicate: 'A part with this serial number is not expected in the shipment',
  serial_id_composite_duplicate: 'serial_id_composite_duplicate',
  serial_id_cannot_receive: 'A part with this serial number already exists in the mobility',
  serail_not_available_to_scan: 'Serial number is not available to scan, ',
  network_error,
  SERIALID_NOT_EXPECTED_IN_SHIPMENT: 'A part with this serial number is not expected in the shipment',
  SERIALID_NOT_EXPECTED_IN_SHIPMENT_PSIR_REQUIRED: 'A part with this serial number is not expected in the shipment. Visually verify the barcode scanned is the serial barcode.',
  SERIALID_NOT_EXPECTED_IN_SHIPMENT_PSIR_NOT_REQUIRED: 'A part with this serial number is not expected in the shipment. Visually verify the barcode scanned is the serial barcode.',
  COMPOSITE_DUPLICATE_SERIAL: 'serial_id_composite_duplicate',
  SERIAL_ALREADY_EXISTS: 'A part with this serial number already exists in the mobility',
  SERIAL_SPECIAL_CHARACTERS: 'Serial number is not allowed to have special characters, Enter site spcific label to continue',
  MPN_NOT_EXPECTED_IN_RECEIVE_REFERENCE: 'The MPN and Serial combination was not expected',
  FAILED_VALIDATION: 'Part failed to receive with failed validation',
  FAILED_LINE_ITEM_RECONCILIATION: 'Part unable to be received into the receive system',
  FAILED_INVENTORY_UPDATE: 'Part unable to be ingested to Mobility',
  MPN_IPN_COMBINATION_NOT_FOUND: 'The MPN and IPN combination was not found',
  COMPOSITE_DUPLICATE_SERIAL_INVALID_STATE: 'A part with this serial number is in bad state',
  MOBILITY_SERVICE_NOT_AVAILABLE: 'Mobility is currently unavailable, please retry in a few minutes.',
  TOWNSEND_IDENTIFIER_COMBINATION_INVALID: 'Townsend catalog identifier(s) (such as MPN, IPN, and manufacturer) are incorrect',
  SERIAL_ALREADY_RECEIVED_FOR_SHIPMENT: 'The serial is already received for this shipment',

  // ERROR codes mapping for Execution Service
  SERIAL_DUPLICATE_SITE_SPECIFIC_VALIDATION: "Non composite duplicate serial, try receiving again by enter site specific serial",
  SERIAL_DUPLICATE_COMPOSITE_MATCH_VALIDATION: "Composite Duplicate Serial, sideline serial and create an exception",
  INVENTORY_ADJUSTMENT_SERIAL_FAILURE_DUPLICATE_INVENTORY_MODIFICATION: "Duplicate Serial. If non-composite, try receiving again by entering site specific serial. If composite,",
  INVENTORY_ADJUSTMENT_SERIAL_FAILURE_UNEXPECTED_INVENTORY_MODIFICATION: "Something went wrong, try receiving again the valid item. ",
  INVENTORY_ADJUSTMENT_SERIAL_FAILURE_THROTTLED_INVENTORY_MODIFICATION: "Something went wrong, try receiving again the valid item. ",
  SERIAL_MPN_NOT_EXPECTED_IN_RECEIVE_VALIDATION: "Something went wrong, try receiving again the valid item.",
  SCOS_RECEIPTS_NOTIFY_FAILURE_DEPENDENCY_NOTIFICATION: "SCOS_RECEIPTS_NOTIFY_FAILURE_DEPENDENCY_NOTIFICATION",
  SERIAL_UNEXPECTED_ERROR: "Something went wrong, refer to above failure message.",
  SERIAL_DUPLICATE_ERROR: "Duplicate serial number serialID scanned, serial already scanned inside container",
  SERIAL_TOWNSEND_IDENTIFIER_COMBINATION_INVALID_VALIDATION: "Serial has incorrect Townsend identifier(s) associated with it, such as MPN, APN, or manufacturer.",
};

export const WARNING_ERROR_CODES = [
  SERIAL_ERROR_CODES.SERIALID_NOT_EXPECTED_IN_SHIPMENT_PSIR_NOT_REQUIRED,
  SERIAL_ERROR_CODES.SERIALID_NOT_EXPECTED_IN_SHIPMENT_PSIR_REQUIRED,
  SERIAL_ERROR_CODES.SERIALID_NOT_EXPECTED_IN_SHIPMENT,
  SERIAL_ERROR_CODES.serial_id_not_exists_asn,
  SERIAL_ERROR_CODES.SERIAL_EXPECTED_IN_SHIPMENT,
];

export const BLOCKING_SERIAL_ERRORS = [SERIAL_ERROR_CODES.serial_id_duplicate];

export const SERIAL_ID_VALIDATION_FAILED_METRIC = 'SerialValidationFailed'

export const MOBILITY_TICKET_URL = "https://t.corp.amazon.com/create/templates/6c6cc015-fb59-432f-b284-bf3edeb968b4";
